var map = {
	"./deathknight.png": 4574,
	"./demonhunter.png": 3516,
	"./druid.png": 8207,
	"./evoker.png": 5397,
	"./hunter.png": 4125,
	"./mage.png": 5021,
	"./monk.png": 9798,
	"./paladin.png": 9498,
	"./priest.png": 954,
	"./rogue.png": 273,
	"./shaman.png": 4617,
	"./warlock.png": 8824,
	"./warrior.png": 7409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3236;